import { Button } from 'primereact/button'
import classes from './ActionsColumn.module.scss'
import './ActionColumn.scss'

const ActionsColumn = ({ assetId }: { assetId: string }) => {
  const createCMURL = (assetId: string) => {
    const url = new URL(`${process.env.REACT_APP_CM_URL}`)

    url.searchParams.append('addNewCert', 'true')
    url.searchParams.append('assetId', assetId)

    return url
  }

  const handleCreateNewCert = () => {
    const url = createCMURL(assetId)
    window.open(url, '_blank')
  }

  return (
    <Button
      onClick={handleCreateNewCert}
      className={classes['create-new-cert-btn']}
      tooltip="Create new certificate"
      tooltipOptions={{ position: 'bottom', className: 'create-cert-tooltip' }}
      icon={
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="19px"
          viewBox="0 -960 960 960"
          width="19px"
          fill="#000000"
        >
          <path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v268q-19-9-39-15.5t-41-9.5v-243H200v560h242q3 22 9.5 42t15.5 38H200Zm0-120v40-560 243-3 280Zm80-40h163q3-21 9.5-41t14.5-39H280v80Zm0-160h244q32-30 71.5-50t84.5-27v-3H280v80Zm0-160h400v-80H280v80ZM720-40q-83 0-141.5-58.5T520-240q0-83 58.5-141.5T720-440q83 0 141.5 58.5T920-240q0 83-58.5 141.5T720-40Zm-20-80h40v-100h100v-40H740v-100h-40v100H600v40h100v100Z" />
        </svg>
      }
    />
  )
}

export default ActionsColumn
